
namespace RioERP.Inventory {
    export class PendriveOutwardColumns {
        static columnsKey = 'Inventory.PendriveOutward';
    }
}